import Vue from 'vue';

export default {
  namespaced: true,
  state: () => ({
    TiposCredito:[],
    Comportamientos:[
      { id:"REV", text: "REVOLVENTE" },
      { id:"FIN", text: "FINANCIAMIENTO" },
      { id:"CON", text: "CONCEPTOS" }
    ]
  }),
  getters: {
    getTiposCredito(state) {
      return state.TiposCredito;
    },
    getComportamientos(state){
      return state.Comportamientos;
    }
  },
  mutations: {
    setTiposCredito(state, data) {
      state.TiposCredito = data;
    },
  },
  actions: {
    async getTiposCredito({commit,rootGetters}) {
      const database  = rootGetters.getFirebaseApp.database;
      let snapshot = await database.queryBuilder("BNK/TiposLineaCredito", []);
      if (snapshot.exists()) {
        let dep = Object.entries(snapshot.val());
        let tipos = [];
        dep.forEach((el) => {
          tipos.push({ id: el[0], ...el[1] });
        });
        commit('setTiposCredito', tipos)
      }else{
        commit('setTiposCredito', [])
      }
    },
  }
}